import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class HtmlLangService {
  html: any = null;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private translate: TranslateService,
  ) {
    this.html = this.document.querySelector("html");

    this.translate.onLangChange.subscribe((data) => {
      this.changeLang(data.lang);
    });
  }

  public changeLang(lang: string) {
    this.html.setAttribute("lang", lang);
  }
}
